import createReactComponent from '../createReactComponent';
export default createReactComponent('user-bolt', 'IconUserBolt', [
  ['path', { d: 'M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0', key: 'svg-0' }],
  [
    'path',
    { d: 'M6 21v-2a4 4 0 0 1 4 -4h4c.267 0 .529 .026 .781 .076', key: 'svg-1' },
  ],
  ['path', { d: 'M19 16l-2 3h4l-2 3', key: 'svg-2' }],
]);
